<script setup lang="ts">
type TItem = {
    title: string,
    groups: Array<{
        title: string,
        state: 0 | 1 | 2,
        icon: string
    }>
}
const props = defineProps<{
    title: string,
    desc: string
}>();
const device = useDevice();
const tabsContainer = useTemplateRef('tabsContainer');
const tabsParent = useTemplateRef('tabsParent');
const tabs = useTemplateRef('tabs');
const tabsIndicator = useTemplateRef('tabsIndicator');
const activeItem = ref<TItem>();
const items: TItem[] = [
    { 
        title: 'تیم فروش',
        groups: [
            { title: 'انبار', state: 0, icon: 'solar:garage-linear' },
            { title: 'اشخاص', state: 2, icon: 'solar:users-group-two-rounded-linear' },
            { title: 'شرکت‌ها', state: 2, icon: 'solar:buildings-2-linear' },
            { title: 'تیکت‌', state: 0, icon: 'solar:ticket-linear' },
            { title: 'حقوق و سطوح دسترسی', state: 1, icon: 'solar:key-linear' },
            { title: 'سرنخ‌', state: 2, icon: 'solar:magnet-wave-linear' },
            { title: 'فرصت فروش', state: 2, icon: 'solar:money-bag-linear' },
            { title: 'محصولات', state: 2, icon: 'solar:box-minimalistic-linear' },
            { title: 'وظیفه‌', state: 2, icon: 'solar:laptop-minimalistic-linear' },
            { title: 'فاکتور', state: 2, icon: 'solar:bill-check-linear' },
            { title: 'اتصال به مرکز تلفن', state: 1, icon: 'solar:headphones-round-sound-linear' },
            { title: 'اتصال به واتس‌اپ', state: 1, icon: 'solar:outgoing-call-rounded-linear' },
            { title: 'یکپارچگی با چت آنلاین', state: 1, icon: 'solar:chat-round-dots-linear' },
            { title: 'یکپارچگی با پنل پیامکی', state: 1, icon: 'solar:chat-square-check-linear' },
            { title: 'کلیک تو کال', state: 1, icon: 'solar:outgoing-call-rounded-linear' },
            { title: 'پاپ آپ تماس', state: 1, icon: 'solar:phone-calling-rounded-linear' },
        ]
    },
    { 
        title: 'تیم پشتیبانی',
        groups: [
            { title: 'انبار', state: 0, icon: 'solar:garage-linear' },
            { title: 'اشخاص', state: 2, icon: 'solar:users-group-two-rounded-linear' },
            { title: 'شرکت‌ها', state: 2, icon: 'solar:buildings-2-linear' },
            { title: 'تیکت‌', state: 2, icon: 'solar:ticket-linear' },
            { title: 'حقوق و سطوح دسترسی', state: 1, icon: 'solar:key-linear' },
            { title: 'سرنخ‌', state: 0, icon: 'solar:magnet-wave-linear' },
            { title: 'فرصت فروش', state: 0, icon: 'solar:money-bag-linear' },
            { title: 'محصولات', state: 0, icon: 'solar:box-minimalistic-linear' },
            { title: 'وظیفه‌', state: 2, icon: 'solar:laptop-minimalistic-linear' },
            { title: 'فاکتور', state: 0, icon: 'solar:bill-check-linear' },
            { title: 'اتصال به مرکز تلفن', state: 1, icon: 'solar:headphones-round-sound-linear' },
            { title: 'اتصال به واتس‌اپ', state: 1, icon: 'solar:outgoing-call-rounded-linear' },
            { title: 'یکپارچگی با چت آنلاین', state: 1, icon: 'solar:chat-round-dots-linear' },
            { title: 'یکپارچگی با پنل پیامکی', state: 1, icon: 'solar:chat-square-check-linear' },
            { title: 'کلیک تو کال', state: 1, icon: 'solar:outgoing-call-rounded-linear' },
            { title: 'پاپ آپ تماس', state: 1, icon: 'solar:phone-calling-rounded-linear' },
        ]
    },
    { 
        title: 'تیم بازاریابی',
        groups: [
            { title: 'انبار', state: 0, icon: 'solar:garage-linear' },
            { title: 'اشخاص', state: 2, icon: 'solar:users-group-two-rounded-linear' },
            { title: 'شرکت‌ها', state: 2, icon: 'solar:buildings-2-linear' },
            { title: 'تیکت‌', state: 0, icon: 'solar:ticket-linear' },
            { title: 'حقوق و سطوح دسترسی', state: 1, icon: 'solar:key-linear' },
            { title: 'سرنخ‌', state: 2, icon: 'solar:magnet-wave-linear' },
            { title: 'فرصت فروش', state: 0, icon: 'solar:money-bag-linear' },
            { title: 'محصولات', state: 2, icon: 'solar:box-minimalistic-linear' },
            { title: 'وظیفه‌', state: 2, icon: 'solar:laptop-minimalistic-linear' },
            { title: 'فاکتور', state: 0, icon: 'solar:bill-check-linear' },
            { title: 'اتصال به مرکز تلفن', state: 1, icon: 'solar:headphones-round-sound-linear' },
            { title: 'اتصال به واتس‌اپ', state: 1, icon: 'solar:outgoing-call-rounded-linear' },
            { title: 'یکپارچگی با چت آنلاین', state: 1, icon: 'solar:chat-round-dots-linear' },
            { title: 'یکپارچگی با پنل پیامکی', state: 1, icon: 'solar:chat-square-check-linear' },
            { title: 'کلیک تو کال', state: 1, icon: 'solar:outgoing-call-rounded-linear' },
            { title: 'پاپ آپ تماس', state: 1, icon: 'solar:phone-calling-rounded-linear' },
        ]
    },
    { 
        title: 'تیم مالی',
        groups: [
            { title: 'انبار', state: 2, icon: 'solar:garage-linear' },
            { title: 'اشخاص', state: 2, icon: 'solar:users-group-two-rounded-linear' },
            { title: 'شرکت‌ها', state: 2, icon: 'solar:buildings-2-linear' },
            { title: 'تیکت‌', state: 0, icon: 'solar:ticket-linear' },
            { title: 'حقوق و سطوح دسترسی', state: 1, icon: 'solar:key-linear' },
            { title: 'سرنخ‌', state: 0, icon: 'solar:magnet-wave-linear' },
            { title: 'فرصت فروش', state: 2, icon: 'solar:money-bag-linear' },
            { title: 'محصولات', state: 2, icon: 'solar:box-minimalistic-linear' },
            { title: 'وظیفه‌', state: 0, icon: 'solar:laptop-minimalistic-linear' },
            { title: 'فاکتور', state: 2, icon: 'solar:bill-check-linear' },
            { title: 'اتصال به مرکز تلفن', state: 1, icon: 'solar:headphones-round-sound-linear' },
            { title: 'اتصال به واتس‌اپ', state: 1, icon: 'solar:outgoing-call-rounded-linear' },
            { title: 'یکپارچگی با چت آنلاین', state: 1, icon: 'solar:chat-round-dots-linear' },
            { title: 'یکپارچگی با پنل پیامکی', state: 1, icon: 'solar:chat-square-check-linear' },
            { title: 'کلیک تو کال', state: 1, icon: 'solar:outgoing-call-rounded-linear' },
            { title: 'پاپ آپ تماس', state: 1, icon: 'solar:phone-calling-rounded-linear' },
        ]
    },
    { 
        title: 'تیم مدیریت',
        groups: [
            { title: 'انبار', state: 2, icon: 'solar:garage-linear' },
            { title: 'اشخاص', state: 2, icon: 'solar:users-group-two-rounded-linear' },
            { title: 'شرکت‌ها', state: 2, icon: 'solar:buildings-2-linear' },
            { title: 'تیکت‌', state: 2, icon: 'solar:ticket-linear' },
            { title: 'حقوق و سطوح دسترسی', state: 1, icon: 'solar:key-linear' },
            { title: 'سرنخ‌', state: 0, icon: 'solar:magnet-wave-linear' },
            { title: 'فرصت فروش', state: 2, icon: 'solar:money-bag-linear' },
            { title: 'محصولات', state: 2, icon: 'solar:box-minimalistic-linear' },
            { title: 'وظیفه‌', state: 2, icon: 'solar:laptop-minimalistic-linear' },
            { title: 'فاکتور', state: 2, icon: 'solar:bill-check-linear' },
            { title: 'اتصال به مرکز تلفن', state: 1, icon: 'solar:headphones-round-sound-linear' },
            { title: 'اتصال به واتس‌اپ', state: 1, icon: 'solar:outgoing-call-rounded-linear' },
            { title: 'یکپارچگی با چت آنلاین', state: 1, icon: 'solar:chat-round-dots-linear' },
            { title: 'یکپارچگی با پنل پیامکی', state: 1, icon: 'solar:chat-square-check-linear' },
            { title: 'کلیک تو کال', state: 1, icon: 'solar:outgoing-call-rounded-linear' },
            { title: 'پاپ آپ تماس', state: 1, icon: 'solar:phone-calling-rounded-linear' },
        ]
    },
];

function scrollIntoViewActiveTab(elem: HTMLSpanElement | undefined) {
  if (!elem || !tabs.value || !tabsContainer.value || device.isDesktop.value) return;

  const containerRect = tabsContainer.value.getBoundingClientRect();
  const elemRect = elem.getBoundingClientRect();
  const offset = elemRect.left - containerRect.left - containerRect.width / 2 + elemRect.width / 2;
  tabsContainer.value?.scrollBy({ left: offset });
};

const getItems = computed(() => {
    if (!device.isDesktop.value) return activeItem.value?.groups;

    const result = [];
    const data = activeItem.value?.groups || items[0]!.groups;
    const itemsPerRow = 4;
    const totalRows = Math.ceil(data.length / itemsPerRow);
    const offItem = { title: 'یکپارچگی با چت آنلاین', icon: 'solar:box-minimalistic-linear', state: 0 };
    for (let row = 0; row < totalRows; row++) {
        const start = row * itemsPerRow;
        result.push(offItem);
        for (let col = 0; col < itemsPerRow; col++) {
            const item = data[start + col];
            if (item)
                result.push(item);
            else
                result.push(item);
        }
        result.push(offItem);
    }

    for (let i = 0; i < 6; i++) {
        result.push(offItem);
    }

    return result;
});

function activeTab(index: number) {
    if(!tabs.value) return;

    activeItem.value = items[index];
    moveActiveIndicator(tabsParent, tabsIndicator, tabs, index);
    scrollIntoViewActiveTab(tabs.value[index]);
};
function handleOnClickTab(index: number) {
    activeTab(index);
};

onMounted(async () => {
    await nextTick();
    activeTab(0);
});
</script>

<template>
    <SectionsBase id="facilities" class="bg-linear-to-b from-gray-50 to-transparent">
        <div class="container">
            <ChipsDivider>امکانات</ChipsDivider>
            <h2>{{ props.title }}</h2>
            <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
            <div class="w-full mt-3">
                <template v-if="!device.isDesktop.value">
                    <div 
                        ref="tabsContainer"
                        class="w-full overflow-y-hidden no-scrollbar h-14.5 flex items-center rounded-full p-3
                            bg-primary-50 relative"
                    >
                        <div ref="tabsParent" class="w-max relative top-0 right-0 flex items-center gap-4">
                            <svg 
                                ref="tabsIndicator" 
                                class="absolute h-full bg-white transition-transform duration-500 rounded-full 
                                    right-0 shadow-primary-xs"
                            ></svg>
                            <span 
                                v-for="item, index in items"
                                :key="item.title"
                                ref="tabs"
                                class="w-max text-body1-semibold p-2 text-primary-600 cursor-pointer select-none relative z-1"
                                @click="handleOnClickTab(index)"
                            >
                                {{ item.title }}
                            </span>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="w-full flex justify-center">
                        <div
                            ref="tabsParent"
                            class="w-fit flex items-center gap-6 rounded-full relative bg-primary-50 p-2"
                        >
                            <svg 
                                ref="tabsIndicator" 
                                class="absolute h-[calc(100%-16px)] bg-white transition-transform duration-500 rounded-full 
                                    right-0 shadow-primary-xs"
                            ></svg>
                            <span 
                                v-for="item, index in items"
                                :key="item.title"
                                ref="tabs"
                                class="text-body1-semibold py-2 px-4 text-primary-600 cursor-pointer select-none relative z-1"
                                @click="handleOnClickTab(index)"
                            >
                                {{ item.title }}
                            </span>
                        </div>
                    </div>
                </template>
                <div class="w-full grid grid-cols-2 lg:grid-cols-6 mt-6">
                    <div 
                        v-for="group, index in getItems"
                        :key="index"
                        class="w-full h-[100px] flex-center flex-col gap-2 px-2 py-3 bg-white border
                            shadow-gray-xs text-gray-400 transition-all duration-100"
                        :class="[
                            group?.state === 0 && 'opacity-50 blur-[3px] bg-transparent! border-gray-100',
                            group?.state === 1 && 'border-gray-200',
                            group?.state === 2 && 'text-primary-600 bg-linear-to-b from-primary-50 to-white border-primary-50',
                        ]"
                    >
                        <Icon :name="group?.icon ?? ''" size="24" />
                        <span class="text-caption lg:text-[1rem]! lg:font-normal!">{{ group?.title }}</span>
                    </div>
                </div>
            </div>
        </div>
    </SectionsBase>
</template>